import { NavLink } from 'react-router-dom';
import { Box, Breadcrumbs } from '@mantine/core';

interface ReportPageNavigationProps {
  reportName: string;
}

export const ReportPageNavigation = ({ reportName }: ReportPageNavigationProps) => {
    const breadcrumbs = [
        { title: 'Home', href: '/dashboard' },
        { title: 'Reports', href: '/reports' },
        { title: reportName }
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};